import { render, staticRenderFns } from "./InsuranceTermsDialog.vue?vue&type=template&id=64750da9&scoped=true&"
import script from "./InsuranceTermsDialog.vue?vue&type=script&lang=js&"
export * from "./InsuranceTermsDialog.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceTermsDialog.vue?vue&type=style&index=0&id=64750da9&prod&scoped=true&lang=pcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64750da9",
  null
  
)

export default component.exports